// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { styled as compiledStyled } from '@compiled/react';
import ShipIcon from '@atlaskit/icon/core/release';
import { token } from '@atlaskit/tokens';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';

const HeaderIcon = (
	props: JSX.LibraryManagedAttributes<typeof AsyncIcon, ComponentProps<typeof AsyncIcon>>,
): React.JSX.Element => (
	<StyledContainer>
		<AsyncIcon
			fallback={() => (
				<BackgroundContainer>
					<ShipIcon spacing="spacious" label="" color={token('color.icon.inverse')} />
				</BackgroundContainer>
			)}
			{...props}
		/>
	</StyledContainer>
);

export default HeaderIcon;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BackgroundContainer = compiledStyled.span<any>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		backgroundColor: token('color.background.neutral.bold'),

		borderRadius: token('radius.xsmall'),
	},
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContainer = compiledStyled.span<any>({
	display: 'inline-flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> img': {
		// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
		borderRadius: token('radius.small', '3px'),
	},
});
